import { topPosts, type PostItem } from "@/mocks/gossipData";

function rankIcon(idx: number) {
  if (idx === 0) return <i className="ri-vip-crown-fill text-accent-500"></i>;
  if (idx === 1) return <i className="ri-star-fill text-accent-400"></i>;
  return <i className="ri-fire-fill text-primary-300"></i>;
}

export default function HighLiked() {
  return (
    <section id="featured" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-thumb-up-fill"></i>
              精华帖 · 高赞内容
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">高赞内容榜</h2>
            <p className="mt-2 text-sm text-foreground-600">被真正点过赞的好内容，含金量经得起反复回看。</p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-archive-2-line"></i>
            本周精华帖合集
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {topPosts.map((item, idx) => (
            <article
              key={item.id}
              className="group flex items-start gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center text-xl">
                {rankIcon(idx)}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2 text-[11px]">
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-800">
                    {item.category}
                  </span>
                  <span className="whitespace-nowrap text-foreground-400">TOP {idx + 1}</span>
                </div>
                <h3 className="mt-2 font-medium leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
                <div className="mt-2.5 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-heart-3-fill text-primary-400"></i>
                    {item.likes.toLocaleString()} 赞
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-chat-3-line"></i>
                    {item.comments.toLocaleString()} 评
                  </span>
                  <span className="whitespace-nowrap rounded-md bg-accent-100 px-2 py-0.5 text-accent-700">{item.tag}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}